import React from 'react';

const ServiceBox = props => {
    return (
        <li className="service-box">
            <div className="service-box__check-box">
                <div className="service-box__box">
                    <svg className="service-box__check" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.83074 22.3134L0.380745 13.8634C-0.126915 13.3557 -0.126915 12.5326 0.380745 12.0249L2.21918 10.1864C2.72684 9.6787 3.55 9.6787 4.05766 10.1864L9.74999 15.8787L21.9423 3.68641C22.45 3.17875 23.2731 3.17875 23.7808 3.68641L25.6192 5.52489C26.1269 6.03255 26.1269 6.85567 25.6192 7.36338L10.6692 22.3134C10.1615 22.8211 9.33841 22.8211 8.83074 22.3134Z" fill="#3C3C3C"/>
                    </svg>
                </div>
            </div>
            <div className="service-box__text-box">
                <span className="service-box__text">
                    {props.treatment}
                </span>
            </div>
        </li>
    );
}

export default ServiceBox;